import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { PopularCreatorList } from "../PopularCreatorsList";
import { useCreators } from "../hooks";
import { Typography } from "@parkschannel/ui";
export const OurCreatorsSection = ()=>{
    const { useCreatorsQuery  } = useCreators();
    const { data: creators  } = useCreatorsQuery({
        page: 1,
        limit: 3,
        search: null
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "py-10 pl-4 md:pl-[30px] lg:px-10 lg:py-[80px]",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full max-w-6xl mx-auto ",
            children: /*#__PURE__*/ _jsxs("section", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h2",
                        className: "pr-4 text-neutral-900 mb-6 md:pr-[30px] lg:mb-[61px]",
                        children: "Get inspired by our creators"
                    }),
                    creators && /*#__PURE__*/ _jsx(PopularCreatorList, {
                        data: creators.data
                    })
                ]
            })
        })
    });
};
